import { RouteObject } from 'react-router-dom';

import { Authorize } from '@/components';
import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';

import { DriverMonitoringPage } from '../pages';

const DriverMonitoringRoutes: RouteObject[] = [
  {
    path: 'driver-monitoring',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.management}
        fallback={<ErrorPage code={403} />}
      >
        <DriverMonitoringPage />
      </Authorize>
    ),
  },
];

export default DriverMonitoringRoutes;
